let UserRolesEnum = {
    WIZARD: 0,
    RESELLER: 1,
    MANAGER: 2,
    EDITOR: 3,
};

export default UserRolesEnum;